import React from 'react';

const NotFoundSvg = () => (
    <svg
        version='1.1'
        id='Layer_1'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        viewBox='0 0 1920 1080'
        enableBackground={'new 0 0 1920 1080'}
        xmlSpace='preserve'
    >
        <g>
            <defs>
                <rect id='SVGID_1_' width='1920' height='1080' />
            </defs>
            <clipPath id='SVGID_00000099642933735050182430000010807903038099996833_'>
                <use xlinkHref='#SVGID_1_' overflow={'visible'} />
            </clipPath>

            <rect
                clipPath='url(#SVGID_00000099642933735050182430000010807903038099996833_)'
                fillRule='evenodd'
                clipRule={'evenodd'}
                fill='#ff0c3d'
                width='1920'
                height='1080'
            />
            <g clipPath='url(#SVGID_00000099642933735050182430000010807903038099996833_)'>
                <path
                    fill='#FFFFFF'
                    d='M473.339,659.037c0.331,0.22,0.661,0.441,0.992,0.661c-1.102-1.102-2.203-2.203-3.305-3.305
			C471.583,657.794,471.987,658.41,473.339,659.037z'
                />
                <path
                    fill='#FFFFFF'
                    d='M469.703,677.215c-1.432-1.542-2.865-3.085-4.297-4.627
			C466.169,674.412,467.716,676.588,469.703,677.215z'
                />
                <path
                    fill='#FFFFFF'
                    d='M472.678,646.147c0,0.331,0,0.661,0,0.992c0.441,0.331,0.881,0.661,1.322,0.992
			C473.595,646.974,473.58,646.78,472.678,646.147z'
                />
                <path
                    fill='#FFFFFF'
                    d='M465.737,689.774c0.11,0,0.22,0,0.331,0c0.11-0.22,0.22-0.441,0.331-0.661
			c-0.771-0.331-1.543-0.661-2.314-0.992C464.636,688.672,465.187,689.223,465.737,689.774z'
                />
                <path
                    fill='#FFFFFF'
                    d='M474.661,698.037c-0.11-0.331-0.22-0.661-0.331-0.992c0,0.331,0,0.661,0,0.992
			C474.441,698.037,474.551,698.037,474.661,698.037z'
                />
                <path
                    fill='#FFFFFF'
                    d='M475.983,690.766c-0.423-1.519-0.665-1.732-1.983-2.314c-0.11,0.22-0.22,0.441-0.331,0.661
			c0.661,0.551,1.322,1.102,1.983,1.653C475.763,690.766,475.873,690.766,475.983,690.766z'
                />
                <path
                    fill='#FFFFFF'
                    d='M527.873,968.062c38.849-25.842,59.364-66.053,84.61-106.424
			c12.925-20.669,26.704-41.08,41.314-60.153c28.613-37.353,67.729-66.889,109.068-91.551
			c21.371-11.567,42.748-23.137,64.119-34.703c30.991-18.631,55.686-41.417,74.034-72.712c15.028-25.632,23.191-55.07,29.085-89.898
			c5.295-31.286-14.394-56.851-6.28-88.246c12.569-48.63,60.446-73.132,79.322-117.992c8.426-20.025,11.492-44.504,16.525-67.754
			c3.197-14.767,3.523-28.312,11.237-38.008c8.953-11.255,34.092-10.456,48.254-4.297c17.813,7.747,29.703,24.255,44.949,35.034
			c10.906,6.94,21.815,13.882,32.72,20.822c12.078,7.058,24.881,12.317,35.695,20.492c8.706,6.581,26.567,25.039,10.246,36.356
			c0-0.331,0-0.661,0-0.992c-3.645,2.002-6.34,4.57-10.907,5.949c-20.231,6.107-41.408-4.617-60.483,0
			c-25.179,6.095-37.431,18.727-50.898,36.356c-4.671,6.115-24.381,32.243-10.907,41.644c11.674,8.145,57.041,4.793,73.704,0.992
			c61.212-13.966,144.818-24.261,173.848-68.415c4.235-6.442,7.076-14.831,8.924-23.466c2.105-9.839,1.46-19.461,4.958-27.763
			c5.975-14.182,20.068-23.585,35.365-28.424c43.732-13.833,104.768-8.364,149.72-19.5c21.308-5.278,42.246-12.389,46.932-34.373
			c3.7-17.356-8.951-43.221-15.865-55.195c-14.681-25.426-16.71-43.126-41.975-58.5c-12.24-7.448-28.061-8.676-44.619-11.568
			c-7.43-1.298-19.054-0.628-23.466-2.314c-3.525,0-7.051,0-10.576,0c-6.169-0.881-12.34-1.763-18.509-2.644
			c-13.326-3.002-26.419-6.933-37.017-13.551c-9.346-5.836-18.011-16.513-21.483-27.102c-0.991-6.279-1.983-12.56-2.975-18.839
			c-2.74-2.383-14.746-0.661-19.17-0.661c-17.956,0-35.917,0-53.873,0c1.419,37.041,33.361,40.458,49.576,62.136
			c9.294,12.425,8.949,30.298-3.636,39.992c-15.681,12.078-42.238,7.037-56.847-2.644c-11.227-7.439-20.51-16.999-30.076-26.11
			c-19.447-18.52-33.35-27.783-39-60.153c-0.904-5.177,1.371-8.864,1.653-13.22c-22.583,0-45.172,0-67.754,0
			c-3.415,2.754-6.831,5.509-10.246,8.263c-6.466,4.013-13.322,6.161-20.491,8.924c-3.525,0.551-7.051,1.102-10.576,1.653
			c-19.769,5.165-39.303,3.972-59.161,7.602c-16.193,1.873-32.391,3.746-48.585,5.619c-5.158,3.441-17.997,2.442-26.771,4.297
			c-15.438,3.262-34.302,5.737-46.932,8.924c-36.454,9.197-73.774,13.957-92.848,39.959c-0.115,0.204-6.144,9.27-6.966,12.262
			c0-0.331,0-0.661,0-0.992c-1.728,1.454-8.474,19-8.593,20.492c-0.22,0.11-0.441,0.22-0.661,0.331c0-0.551,0-1.102,0-1.653
			c-0.11,0-0.22,0-0.331,0c-0.555,1.869-1.082,4.139-1.553,6.28c0.077,0,0.154,0,0.231,0c-0.099,0.099-0.198,0.198-0.296,0.296
			c-0.547,2.5-1.015,4.786-1.356,5.983c-1.21,4.253-4.1,8.398-4.627,13.881c-0.328,0.333-0.279-0.067-0.331-0.331
			c-3.108,2.56-1.959,8.823-3.636,13.551c-4.047,11.411-6.443,21.389-12.229,30.737c-14.552,23.513-38.371,32.502-66.432,42.636
			c-46.027,16.622-131.968,22.772-184.755,6.61c-54.161-16.583-112.313-47.498-181.78-31.729
			c-39.737,9.02-73.731,23.776-100.805,46.602c-5.728,6.059-11.458,12.119-17.186,18.178c0.92,0.633-3.688,7.251-4.627,7.932
			c0.441-0.991,0.881-1.983,1.322-2.975c-0.11,0-0.22,0-0.331,0c-0.551,1.322-1.102,2.644-1.653,3.966
			c0.331-0.22,0.661-0.441,0.992-0.661c-3.679,7.6-6.362,15.561-7.932,25.449c-1.151,7.249-0.717,16.422,0.331,23.466
			c2.392,16.086-3.874,33.958-12.229,39.992c-10.147,7.328-27.485,4.468-36.356-1.983c-8.341-6.066-12.747-16.733-18.839-25.119
			c-12.158-16.736-26.342-29.181-49.576-35.034c-27.812-7.007-70.204,6.529-94.195-5.288c0,34.59,0,69.19,0,103.78
			c20.326-0.11,38.851-0.353,53.873,5.949c14.578,6.116,24.814,17.832,37.017,26.441c13.815,9.747,28.98,15.483,47.593,20.822
			c10.07,2.889,25.19,5.347,37.678,2.644c9.632-2.085,18.736-4.254,27.102-7.602c38.561-15.432,78.439-50.135,88.907-93.204
			c5.215-21.457-5.371-50.428,5.619-67.754c13.95-21.995,59.324-48.18,100.475-39.992c23.147,4.606,44.074,11.742,61.805,22.144
			c8.158,4.786,17.988,9.745,22.475,18.178c2.772,5.21,1.035,12.488-3.636,14.212c-19.553,7.215-55.648-9.197-75.356-12.89
			c-10.833-2.03-23.607,2.964-27.763,8.263c-21.367,27.246,38.529,48.143,17.517,77.009c-8.745,12.014-26.701,16.889-38.67,25.78
			c-12.889,8.703-25.781,17.408-38.67,26.11c-13.13,9.266-25.575,19.599-38.009,29.415c-12.333,9.737-24.883,21.955-31.398,37.347
			c-9.261,21.88,2.537,42.415,11.568,57.509c16.793,28.067,37.618,50.274,49.246,83.619c4.441,12.737,7.541,35.137,1.983,49.246
			c-3.163,8.029-7.925,14.581-12.89,20.822c-8.4,10.56-20.649,18.873-33.051,25.449c-0.991-1.652-1.983-3.305-2.975-4.958
			c-0.22-0.11-0.441-0.22-0.661-0.331c-0.11,0.11-0.22,0.22-0.331,0.331c0.771,1.873,1.543,3.746,2.314,5.619
			c-0.331,0.441-0.661,0.881-0.992,1.322c-0.22,0-0.441,0-0.661,0c-1.488-1.377-2.997-3.444-3.305-5.949
			c-0.22-0.11-0.441-0.22-0.661-0.331c-0.441,0.22-0.881,0.441-1.322,0.661c1.089,2.091,3.274,5.446,2.975,7.602
			c-0.331,0.11-0.661,0.22-0.992,0.331c-1.715-1.591-4.16-5.1-6.28-5.949c0.11,0.991,0.22,1.983,0.331,2.975
			c0.736,0.072,0.209,0.254,0.661-0.331c0.881,1.322,1.763,2.644,2.644,3.966c-0.794,0.798-0.995,0.92-1.322,2.314
			c-0.441,0.11-0.881,0.22-1.322,0.331c-2.076-1.581-4.23-4.023-4.297-7.602c-0.441,0-0.881,0-1.322,0
			c0.153,4.021,1.937,5.569,3.305,8.263c-0.441,0.551-0.881,1.102-1.322,1.653c-1.212-0.22-2.424-0.441-3.636-0.661
			c-0.22-0.11-0.441-0.22-0.661-0.331c0.778-2.023,1.481-1.077,2.975-0.331c0.11-0.441,0.22-0.881,0.331-1.322
			c-1.613-0.18-0.779-1.142-2.975-1.983c-0.453-1.504-0.3-0.422,0.331-1.983c-0.551,0.11-1.102,0.22-1.653,0.331
			c0.441,0.881,0.881,1.763,1.322,2.644c-1.917,2.872-3.896,2.532-5.949,5.288c-1.436,0.102-2.543-0.33-3.966-0.992
			c-0.961,1.054-0.738,0.346-0.331,1.983c-2.833,3.053-10.189,3.153-15.534,7.271c-1.247-0.059-2.219-0.632-3.636-1.322
			c-0.792,0.846-0.137,1.246,0,2.975c-5.835,3.822-27.407,14.502-32.582,20.39c1.606-1.178,3.213-2.356,4.819-3.534
			c0.331,0,0.661,0,0.992,0c-1.405,1.481-2.96,3.478-5.949,3.966c0-0.089,0-0.178,0-0.266c-0.605,0.722-0.967,1.372-0.992,1.919
			c-2.906-0.409-5.935,0.654-8.593,3.636c-0.22,0-0.441,0-0.661,0c0.545,0.499-0.035,0.377,0.661,0.331
			c1.315,0.177,4.684-2.459,5.949-3.636c0.11,0,0.22,0,0.331,0c-0.545,2.08-5.389,5.712-7.271,7.932
			c-1.408-0.228-0.459,0.539-1.322-0.661c-0.331,0.331-0.661,0.661-0.992,0.992c-0.875,0.495,0.032,0.588,0.331,1.983
			c-4.989,7.293-14.595,13.393-21.814,18.508c-13.867,9.826-33.792,26.908-44.288,39.992C79.9,870.822,59.744,897.81,48.966,933.359
			c-3.33,10.983-5.157,22.882-6.61,34.042c-6.395,49.115,17.611,72.651,45.941,91.551c11.073,7.387,22.977,15.382,37.347,19.169
			c-0.22,0.441-0.441,0.881-0.661,1.322c48.58,0,97.174,0,145.754,0c29.392,0,61.135,0.813,88.907-0.992
			c-5.508-0.771-11.018-1.542-16.525-2.313c-24.013-9.741-41.234-24.164-58.831-39.661c-13.791-12.146-24.203-27.507-32.39-45.28
			c-4.081-8.86-7.134-18.671-10.246-29.085c-1.41-4.719-0.817-7.337-1.983-10.246c-2.701-6.739-3.279-33.426-1.322-41.644
			c1.102-4.186,2.204-8.373,3.305-12.559c0.551-1.322,1.102-2.644,1.653-3.966c-1.31-2.406,3.494-8.69,4.958-10.907
			c7.095-10.744,15.135-15.35,23.136-24.127c14.66-16.082,38.639-26.719,58.5-38.67c30.702-18.474,61.664-36.88,86.263-61.475
			c24.624-24.619,52.22-65.238,35.034-114.026c4,4.148,6.423,22.366,6.941,30.407c4.147-10.608-5.21-35.316-7.602-41.975
			c0.22-0.22,0.441-0.441,0.661-0.661c0.11,0.771,0.22,1.543,0.331,2.314c0.331,0.22,0.661,0.441,0.992,0.661
			c-1.164-8.363-7.156-15.439-10.246-22.475c-9.168-20.878-22.197-38.481-35.365-55.526c-5.614-7.266-20.16-20.663-22.805-29.085
			c-1.064,0.464-0.646,0.332-1.322,0.992c-0.22-0.11-0.441-0.22-0.661-0.331c0.331-0.881,0.661-1.763,0.992-2.644
			c-4.758,0.172-6.608-9.571-10.853-11.867c0.002,0.029,0.006,0.058,0.008,0.087c1.301,2.494,2.603,4.989,3.904,7.483
			c-0.441-0.11-0.881-0.22-1.322-0.331c-1.593-2.657-2.375-4.753-2.582-7.153c-0.021-0.04-0.041-0.079-0.062-0.119
			c0.018,0.01,0.036,0.022,0.054,0.032c-0.163-2.034,0.081-4.291,0.607-7.303c-3.39,3.54-3.414,11.406-2.644,17.186
			c-0.11,0-0.22,0-0.331,0c-6.473-21.857,12.747-36.078,25.78-44.288c25.139-15.837,56.338-27.236,84.28-39.661
			c17.74-7.888,33.8-19.916,48.254-31.398c10.48-8.325,18.762-21.024,23.136-35.364c2.423-7.944,3.376-16.105,7.271-22.475
			c8.07-13.196,23.862-23.071,38.67-29.415c46.839-20.067,108.37-27.701,160.958-40.983c26.15-6.605,53.359-12.955,72.712-26.771
			c14.155-10.105,13.432-30.096,18.839-49.246c0.413,0.613,0.321-0.591,0.331-0.661c1.652-6.83,3.305-13.662,4.958-20.492
			c5.179-13.32,9.461-32.086,18.508-46.932c20.011-32.834,54.707-47.873,96.178-60.153c10.167-3.011,21.903-3.051,30.407-5.288
			c15.768-4.149,46.897-4.981,63.788-0.992c4.198,0.991,23.3,4.651,24.788,5.619c4.814,3.133,19.581,7.914,29.085,9.585
			c-0.316,0.883,0.343,0.349-0.661,0.992c5.328,4.066,16.39,7.011,22.475,10.246c-0.22-0.661-0.441-1.322-0.661-1.983
			c4.221,2.936,12.076,7.443,18.508,11.568c1.873,1.201,3.249,0.333,4.297,1.322c0.22,0,0.441,0,0.661,0
			c-0.22,0.11-0.441,0.22-0.661,0.331c3.57,4.171,21.961,11.593,28.754,15.864c27.733,17.438,52.136,36.364,97.831,36.356
			c8.286-0.002,16.55,0.533,23.797-0.992c10.859-2.285,21.359-3.777,31.068-6.941c18.589-6.057,34.096-16.437,49.246-26.11
			c9.615-6.138,18.227-13.443,30.737-16.856c27.599-7.528,47.924,2.355,57.839,21.814c2.063,4.048,5.356,10.836,3.966,17.848
			c-7.811,39.395-64.152,39.84-103.78,52.551c-17.515,4.847-35.036,9.695-52.551,14.542c-24.325,10.165-67.515,28.893-99.814,16.195
			c-19.44-7.643-32.999-20.632-47.593-33.051c-1.646-1.401-1.851-3.582-2.644-4.958c-4.847-3.855-9.695-7.712-14.542-11.568
			c-19.1-13.579-41.737-26.041-65.11-34.703c-10.589-3.924-23.066-5.279-33.051-10.246c-1.568,1.086-8.883-0.727-11.237-1.322
			c-14.373-3.63-36.383-5.496-46.271-2.644c-13.31,3.839-27.841,8.189-37.348,15.534c-21.207,16.386-38.019,49.585-46.271,79.983
			c-6.866,25.292-7.315,54.835-17.186,76.678c-10.812,23.923-34.311,46.191-51.229,65.441
			c-16.812,19.129-26.424,44.056-31.729,74.695c-0.22,13.88-0.441,27.764-0.661,41.644c-0.661,9.363-1.322,18.73-1.983,28.093
			c-5.413,26.143-10.362,52.36-28.093,66.102c-7.209,5.587-16.059,10.16-25.449,13.551c-3.133,1.131-8.949,3.668-11.568,0.992
			c-0.958-0.925,0.017-0.191-0.331-1.322c-1.322-0.11-2.644-0.22-3.966-0.331c-0.466-3.279-1.481-2.145-2.975-4.958
			c-0.331-0.22-0.661-0.441-0.992-0.661c0.331,0.991,0.661,1.983,0.992,2.975c-0.22,0.11-0.441,0.22-0.661,0.331
			c-1.708-0.529-2.215-0.72-3.305-1.653c0.11,0.441,0.22,0.881,0.331,1.322c-0.11,0.331-0.22,0.661-0.331,0.992
			c-0.551-0.11-1.102-0.22-1.653-0.331c-0.84-0.705-0.832-0.845-0.992-2.314c-0.22-0.11-0.441-0.22-0.661-0.331
			c0.22,1.102,0.441,2.204,0.661,3.305c-2.248,0.568-2.071-0.031-3.966,0.992c-0.941-0.941-1.01-2.723-1.653-3.966
			c0-0.22,0-0.441,0-0.661c-0.11,1.212-0.22,2.424-0.331,3.636c-1.182,1.193-5.593,1.805-7.271,1.983
			c-0.22-0.991-0.441-1.983-0.661-2.975c-0.22-0.11-0.441-0.22-0.661-0.331c0.11,0.881,0.22,1.763,0.331,2.644
			c-0.11,0.331-0.22,0.661-0.331,0.992c-0.441,0-0.881,0-1.322,0c-0.11-0.441-0.22-0.881-0.331-1.322
			c-0.909,0.24-0.938,0.422-1.653,1.653c-0.551,0-1.102,0-1.653,0c-0.22-0.881-0.441-1.763-0.661-2.644c-0.11,0-0.22,0-0.331,0
			c-0.22,0.771-0.441,1.542-0.661,2.314c-0.331,0.22-0.661,0.441-0.992,0.661c-1.368-0.902-1.862-2.19-2.314-3.966
			c-0.22-0.11-0.441-0.22-0.661-0.331c0.22,0.991,0.441,1.983,0.661,2.975c-0.331,0.441-0.661,0.881-0.992,1.322
			c-0.11,0-0.22,0-0.331,0c-0.847-1.799-1.694-3.599-2.54-5.398c0.186,1.579,0.372,3.158,0.557,4.737c0,0.11,0,0.22,0,0.331
			c-0.661,0-1.322,0-1.983,0c-1.157-0.666-1.426-1.43-1.983-2.644c-0.661-0.22-1.322-0.441-1.983-0.661
			c0.661,0.991,1.322,1.983,1.983,2.975c0,0.11,0,0.22,0,0.331c-4.517-0.11-9.034-0.22-13.551-0.331c0-0.771,0-1.543,0-2.314
			c-0.11-0.11-0.22-0.22-0.331-0.331c-0.661,0.881-1.322,1.763-1.983,2.644c-2.834-1.447-5.807-1.841-9.585-1.653
			c-0.667-2.307-1.606-5.181-4.627-5.949c0,0.11,0,0.22,0,0.331c0.771,0.881,1.542,1.763,2.314,2.644
			c0.723,0.681,0.641,0.446,0.992,1.653c-0.22,0.11-0.441,0.22-0.661,0.331c-3.763-1.733-9.515-3.384-13.22-4.627
			c-2.093,0-4.187,0-6.28,0c-3.314-0.948-6.457-4.114-10.576-4.297c-0.536-1.414-0.313-0.869,0-2.644
			c-8.35-0.379-23.159-13.443-25.78-19.831c0.18-1.307,0.252-1.078-0.661-1.983c-3.276,3.238-1.73,6.683-0.992,11.237
			c-8.672-8.129,3.726-20.802,9.254-23.797c9.397-5.09,20.187-4.464,33.051-6.941c24.956-4.806,45.875-5.449,57.178-23.466
			c8.529-13.595,8.086-35.756,4.297-54.865c-1.365-6.885-2.52-17.773-0.992-25.78c2.314-12.122,3.762-23.333,7.932-33.381
			c6.389-12.228,12.78-24.459,19.17-36.686c4.298-9.922,8.693-25.84-4.627-29.415c-14.405-3.867-31.113,1.125-43.297,5.288
			c-31.015,10.599-56.446,24.993-68.746,53.542c-5.541,12.861-3.567,34.072-10.576,45.941
			c-23.416,39.651-100.166,43.453-111.381,92.212c-2.674,11.624,1.778,22.988,4.958,31.068
			c8.086,20.549,18.092,38.713,28.754,56.848c27.549,46.855,23.867,106.352-2.644,151.373
			c-22.477,38.171-42.999,60.571-84.61,79.653c-28.426,13.036-69.347,19.117-92.542,37.348
			c-9.482,7.453-17.978,23.762-11.237,40.653c2.313,4.847,4.627,9.695,6.941,14.542c1.228,1.656,5.486,5.516,5.288,5.288
			c3.906,3.372,9.376,10.544,14.873,15.203c7.914,6.708,16.227,11.239,26.11,16.195c4.104,2.058,9.642,5.492,14.873,5.949
			c0-0.11,0-0.22,0-0.331c-1.102-0.331-2.203-0.661-3.305-0.992c0-0.11,0-0.22,0-0.331
			C467.638,997.012,499.397,987.004,527.873,968.062z M212.568,754.884c-0.11,0-0.22,0-0.331,0c0.11-0.661,0.22-1.322,0.331-1.983
			c1.11,0.458,0.689,0.19,1.322,0.992C213.449,754.223,213.008,754.554,212.568,754.884z M230.085,748.605c-0.11,0-0.22,0-0.331,0
			c0.22-0.551,0.441-1.102,0.661-1.653c0.11,0.441,0.22,0.881,0.331,1.322C230.525,748.384,230.305,748.494,230.085,748.605z
			 M239.669,744.308c-0.331,0.22-0.661,0.441-0.992,0.661c-0.551,0-1.102,0-1.653,0c0.551-0.991,1.102-1.983,1.653-2.975
			c0.331,0.22,0.661,0.441,0.992,0.661C239.669,743.206,239.669,743.757,239.669,744.308z M252.229,737.367
			c-0.11-0.11-0.22-0.22-0.331-0.331c0.11-0.331,0.22-0.661,0.331-0.992c0.331,0.22,0.661,0.441,0.992,0.661
			C252.89,736.927,252.559,737.147,252.229,737.367z M1120.806,87.256c-0.11,0-0.22,0-0.331,0c-0.331-0.331-0.661-0.661-0.991-0.992
			c0.441,0.11,0.881,0.22,1.322,0.331C1120.806,86.816,1120.806,87.036,1120.806,87.256z M1134.357,92.875
			c0.987,0.427,0.396-0.014,0.991,0.661C1135.018,93.316,1134.688,93.095,1134.357,92.875z M749.314,592.604
			c0.331,0,0.661,0,0.992,0c-0.37,1.196-0.261,0.971-0.992,1.653C749.314,593.706,749.314,593.155,749.314,592.604z
			 M651.814,582.028c0.22,0.331,0.441,0.661,0.661,0.992c-0.881-0.22-1.763-0.441-2.644-0.661c-0.11-0.441-0.22-0.881-0.331-1.322
			C650.271,581.367,651.043,581.698,651.814,582.028z'
                />
                <path
                    fill='#FFFFFF'
                    d='M740.06,587.977c0.11,0,0.22,0,0.331,0c-0.11-0.331-0.22-0.661-0.331-0.992
			C740.06,587.316,740.06,587.647,740.06,587.977z'
                />
                <path
                    fill='#FFFFFF'
                    d='M793.602,122.621c-0.11,0.22-0.22,0.441-0.331,0.661c0.122-0.122,0.243-0.243,0.365-0.365
			c0.022-0.099,0.043-0.197,0.065-0.296C793.668,122.621,793.635,122.621,793.602,122.621z'
                />
                <path
                    fill='#FFFFFF'
                    d='M657.763,579.714c-0.11,0.22-0.22,0.441-0.331,0.661c0.22,0,0.441,0,0.661,0
			C657.983,580.155,657.873,579.935,657.763,579.714z'
                />
                <path
                    fill='#FFFFFF'
                    d='M663.382,584.011c0-0.441,0-0.881,0-1.322c-0.331,0-0.661,0-0.992,0c0,0.441,0,0.881,0,1.322
			C662.721,584.011,663.051,584.011,663.382,584.011z'
                />
                <path
                    fill='#FFFFFF'
                    d='M687.509,592.935c0.11,0,0.22,0,0.331,0c0.22-0.22,0.441-0.441,0.661-0.661
			c-0.551-0.11-1.102-0.22-1.653-0.331c-0.11,0.11-0.22,0.22-0.331,0.331C686.848,592.494,687.178,592.714,687.509,592.935z'
                />
                <path
                    fill='#FFFFFF'
                    d='M726.509,592.935c-0.441-0.551-0.881-1.102-1.322-1.653c0.22,0.661,0.441,1.322,0.661,1.983
			c0,0.22,0,0.441,0,0.661C726.068,593.596,726.289,593.265,726.509,592.935z'
                />
                <path
                    fill='#FFFFFF'
                    d='M724.856,591.282c0.11,0,0.22,0,0.331,0c-0.11-0.331-0.22-0.661-0.331-0.992
			C724.856,590.621,724.856,590.952,724.856,591.282z'
                />
                <path
                    fill='#FFFFFF'
                    d='M705.356,592.274c0.22,0.11,0.441,0.22,0.661,0.331c0.11,0,0.22,0,0.331,0
			c-0.179-2.243-1.014-3.527-2.644-4.297C704.525,589.729,705.175,590.001,705.356,592.274z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1393.476,127.909c2.487-2.06,10.146-5.216,8.924-7.602c-3.084,1.983-6.17,3.966-9.254,5.949
			c-11.421,7.695-24.391,19.031-39,22.805c3.254,1.093,9.449-3.202,11.898-4.627
			C1375.583,138.885,1385.314,134.667,1393.476,127.909z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1210.374,139.477c0.802,1.251,2.047,1.868,3.635,2.314
			C1212.798,141.019,1211.586,140.248,1210.374,139.477z'
                />
                <path
                    fill='#FFFFFF'
                    d='M656.772,579.714c0.22-0.22,0.441-0.441,0.661-0.661c-0.22,0-0.441,0-0.661,0
			C656.772,579.274,656.772,579.494,656.772,579.714z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1403.061,120.307c0.33-0.22,0.661-0.441,0.991-0.661c-0.22,0-0.441,0-0.661,0
			C1403.281,119.866,1403.171,120.087,1403.061,120.307z'
                />
                <path
                    fill='#FFFFFF'
                    d='M642.229,569.799c-0.22,0-0.441,0-0.661,0c-0.11,0.22-0.22,0.441-0.331,0.661
			C642.224,570.033,641.634,570.474,642.229,569.799z'
                />
                <path
                    fill='#FFFFFF'
                    d='M644.212,573.765c-0.441-0.331-0.881-0.661-1.322-0.992
			C643.525,573.766,642.947,573.329,644.212,573.765z'
                />
                <path
                    fill='#FFFFFF'
                    d='M635.619,311.011c0.441,0.11,0.881,0.22,1.322,0.331c0-0.11,0-0.22,0-0.331
			C636.5,311.011,636.06,311.011,635.619,311.011z'
                />
                <path
                    fill='#FFFFFF'
                    d='M687.509,299.443c0.881,0,1.763,0,2.644,0c-0.661-0.11-1.322-0.22-1.983-0.331
			C687.95,299.223,687.729,299.333,687.509,299.443z'
                />
                <path
                    fill='#FFFFFF'
                    d='M637.933,310.35c-0.22,0.11-0.441,0.22-0.661,0.331
			C637.987,310.865,637.699,310.662,637.933,310.35z'
                />
                <path
                    fill='#FFFFFF'
                    d='M378.483,519.562c0.22,0.11,0.441,0.22,0.661,0.331c-0.262-1.278-0.194-1.321-0.992-1.983
			C378.263,518.46,378.373,519.011,378.483,519.562z'
                />
                <path
                    fill='#FFFFFF'
                    d='M696.763,297.46c0.441,0.11,0.881,0.22,1.322,0.331c0-0.11,0-0.22,0-0.331
			C697.644,297.46,697.204,297.46,696.763,297.46z'
                />
                <path
                    fill='#FFFFFF'
                    d='M472.017,687.791c0.11,0,0.22,0,0.331,0c-0.331-0.331-0.661-0.661-0.992-0.992
			C471.576,687.13,471.797,687.46,472.017,687.791z'
                />
                <path
                    fill='#FFFFFF'
                    d='M634.297,311.341c0.441,0.11,0.881,0.22,1.322,0.331c0-0.11,0-0.22,0-0.331
			C635.178,311.341,634.738,311.341,634.297,311.341z'
                />
                <path
                    fill='#FFFFFF'
                    d='M753.611,591.613c0.22,0.11,0.441,0.22,0.661,0.331c-0.11-0.991-0.22-1.983-0.331-2.975
			c-0.441-0.22-0.881-0.441-1.322-0.661C752.95,589.409,753.28,590.511,753.611,591.613z'
                />
                <path
                    fill='#FFFFFF'
                    d='M740.06,591.613c0.22,0.11,0.441,0.22,0.661,0.331c-0.331-1.322-0.661-2.644-0.992-3.966
			C739.839,589.189,739.95,590.401,740.06,591.613z'
                />
                <path
                    fill='#FFFFFF'
                    d='M740.721,399.587c2.423-4.957,4.848-9.916,7.271-14.873
			C745.389,388.906,741.784,394.32,740.721,399.587z'
                />
                <path
                    fill='#FFFFFF'
                    d='M728.161,291.511c11.016-2.423,22.035-4.848,33.051-7.271c5.949-1.763,11.899-3.526,17.847-5.288
			c-0.551-0.11-1.102-0.22-1.653-0.331c-7.601,1.873-15.204,3.746-22.805,5.619c-15.532,3.635-31.069,7.272-46.602,10.907
			C712.952,296.561,723.147,292.697,728.161,291.511z'
                />
                <path
                    fill='#FFFFFF'
                    d='M759.229,595.579c-0.441-0.22-0.881-0.441-1.322-0.661c0.11,0.441,0.22,0.881,0.331,1.322
			C758.568,596.02,758.899,595.799,759.229,595.579z'
                />
                <path
                    fill='#FFFFFF'
                    d='M698.416,297.129c1.542-0.11,3.085-0.22,4.627-0.331c-0.551-0.11-1.102-0.22-1.653-0.331
			C700.399,296.689,699.407,296.909,698.416,297.129z'
                />
                <path
                    fill='#FFFFFF'
                    d='M690.153,298.782c0.441,0.11,0.881,0.22,1.322,0.331c0-0.11,0-0.22,0-0.331
			C691.034,298.782,690.594,298.782,690.153,298.782z'
                />
                <path
                    fill='#FFFFFF'
                    d='M103.169,487.503c0.11,0,0.22,0,0.331,0c-0.513-1.383,0.067-0.814-1.322-1.322
			C102.508,486.621,102.839,487.062,103.169,487.503z'
                />
                <path
                    fill='#FFFFFF'
                    d='M2.73,684.99c0.245-0.171,0.488-0.347,0.729-0.527c-0.034-0.103-0.068-0.205-0.103-0.308
			C3.147,684.434,2.938,684.712,2.73,684.99z'
                />
                <path
                    fill='#FFFFFF'
                    d='M2.364,685.477c0.122-0.162,0.244-0.325,0.366-0.487c-1.462,1.021-2.953,1.854-4.001,2.14
			c-0.331,0.551-0.661,1.102-0.992,1.653c3.246-0.639,9.205-4.941,9.254-7.602c-0.747,0.988-2.086,2.201-3.533,3.283
			c0.076,0.228,0.152,0.456,0.228,0.684C3.245,685.257,2.805,685.367,2.364,685.477z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1.042,677.215c0.22,0.11,0.441,0.22,0.661,0.331c-0.771-1.212-1.543-2.424-2.314-3.636
			C-0.06,675.011,0.491,676.113,1.042,677.215z'
                />
                <path
                    fill='#FFFFFF'
                    d='M-0.28,670.935c1.652,1.763,3.305,3.526,4.958,5.288C3.899,674.073,1.736,671.835-0.28,670.935z'
                />
                <path
                    fill='#FFFFFF'
                    d='M-1.272,666.638c0.22-0.22,0.441-0.441,0.661-0.661c-0.22,0-0.441,0-0.661,0
			C-1.272,666.198-1.272,666.418-1.272,666.638z'
                />
                <path
                    fill='#FFFFFF'
                    d='M0.381,684.486c-0.331,0-0.661,0-0.992,0c-0.331,0.22-0.661,0.441-0.992,0.661
			c0.551,0,1.102,0,1.653,0C0.161,684.927,0.271,684.706,0.381,684.486z'
                />
                <path
                    fill='#FFFFFF'
                    d='M103.5,497.418c0.22-0.22,0.441-0.441,0.661-0.661c-0.22,0-0.441,0-0.661,0
			C103.5,496.977,103.5,497.197,103.5,497.418z'
                />
                <path
                    fill='#FFFFFF'
                    d='M103.169,481.223c-0.11,0.22-0.22,0.441-0.331,0.661c0.331,0.22,0.661,0.441,0.992,0.661
			c0.11,0,0.22,0,0.331,0C103.83,482.104,103.5,481.664,103.169,481.223z'
                />
                <path
                    fill='#FFFFFF'
                    d='M12.279,810.74c12.158-12.311,24.866-24.763,38.67-35.364
			c23.843-18.312,48.83-35.899,72.712-53.873c23.252-17.5,48.18-37.553,54.203-72.051c1.778-10.181-1.555-20.499-2.975-29.085
			c0.11,0,0.22,0,0.331,0c1.81,6.484,3.798,12.8,3.636,21.483c0.22,0,0.441,0,0.661,0c2.283-18.152-4.114-37.311-9.585-50.237
			c-3.195-5.838-6.39-11.679-9.585-17.517c-0.794-0.493-0.375-0.2-0.661,0.661c-5.068-4.972-6.308-13.145-11.568-18.508
			c-6.194-6.316-12.407-14.63-17.186-22.144c-7.802-12.266-26.772-27.228-39-35.695c-4.937-3.419-9.51-7.934-15.864-9.915
			c2.864,1.983,5.729,3.966,8.593,5.949c0.22,0.331,0.441,0.661,0.661,0.992c-3.856-0.658-14.041-7.952-15.203-11.568
			c-0.22-0.11-0.441-0.22-0.661-0.331c0.331,1.322,0.661,2.644,0.992,3.966c-3.158-1.247-6.548-5.579-10.246-4.297
			c-0.771-2.423-1.543-4.848-2.314-7.271c-0.11,0-0.22,0-0.331,0c0.441,2.093,0.881,4.187,1.322,6.28
			c-0.22,0.11-0.441,0.22-0.661,0.331c-16.027-6.766-39.198-4.881-60.814-4.627c0,41.971,0,83.953,0,125.924
			c1.983,1.873,3.966,3.746,5.949,5.619c6.629,8.374,12.855,17.855,15.534,30.076c5.262,24.007-5.022,46.004-21.483,50.898
			c0,45.495,0,91.005,0,136.5C3.384,823.467,7.476,815.604,12.279,810.74z M176.542,614.748c-3.002-2.571-7.553-18.139-8.593-23.136
			C172.307,597.592,174.333,607.129,176.542,614.748z'
                />
                <path
                    fill='#FFFFFF'
                    d='M97.22,498.409c0.22,0.331,0.441,0.661,0.661,0.992C97.454,498.414,97.895,499.004,97.22,498.409z'
                />
                <path
                    fill='#FFFFFF'
                    d='M2.364,678.867c0.11,0.331,0.22,0.661,0.331,0.992c0.244-1.078-0.186-1.45-0.992-2.314
			C2.022,678.743,1.681,678.218,2.364,678.867z'
                />
                <path
                    fill='#FFFFFF'
                    d='M4.347,129.892c4.002,4.839,8.381,9.662,12.229,14.542c1.708,2.166,0.542,3.156,1.322,5.288
			c3.631,9.92,9.192,16.596,12.229,27.102c7.36,25.457,2.431,64.37,25.119,74.034c31.383,13.368,75.13-4.588,95.517-15.203
			c25.198-13.121,48.816-32.297,74.695-43.627c40.784-17.857,80.527-28.35,128.898-39.331
			c66.548-15.106,118.802,9.085,173.187,28.424c12.383,4.404,27.598,4.612,42.966,8.924c6.059,0.11,12.119,0.22,18.178,0.331
			c8.255,1.243,15.836-0.438,22.805-1.653c30.325-5.284,54.318-12.09,74.034-28.093c4.171-3.386,21.194-17.931,20.822-22.805
			c0.794-0.493,0.375-0.2,0.661,0.661c1.763-3.195,3.526-6.39,5.288-9.585c11.938-19.938,16.486-46.911,26.441-69.407
			c10.897-24.626,35.651-39.11,62.466-47.924c7.627-2.507,17.312-3.376,23.797-5.288c5.35-1.577,12.684-0.963,17.517-2.314
			c4.011-1.121,9.089-3.104,14.212-2.644c0-0.11,0-0.22,0-0.331s0-0.22,0-0.331c-59.706,0-119.43,0-179.136,0
			c-2.471,1.514-11.118,20.966-13.22,25.78c-14.177,32.459-10.863,76.099-43.958,89.568c-28.95,11.782-77.841,13.862-110.721,3.305
			c-14.761-4.406-29.527-8.814-44.288-13.22c-10.23-2.385-19.591-2.058-30.737-4.297c-6.72-0.551-13.441-1.102-20.161-1.653
			c-10.83,1.05-29.329,1.3-40.322,3.305c-2.754,0.11-5.509,0.22-8.263,0.331c-8.042,1.652-16.086,3.305-24.127,4.958
			c-23.91,6.665-48.083,12.089-70.729,19.831c-16.788,5.739-33.822,8.676-49.907,15.534c-21.096,8.994-64.866,30.584-92.542,20.161
			c-18.881-7.11-30.293-36.225-44.619-50.568c-13.427-13.443-36.079-29.421-40.322-50.898
			c-4.524-22.897,34.734-49.806,60.814-40.653c13.991,4.911,18.111,16.845,25.78,28.093c12.599,18.479,25.653,33.584,50.237,40.322
			c14.206,3.893,33.644,3.893,47.593,1.322c11.524-2.124,24.331-2.609,34.703-6.28c24.094-8.526,47.945-16.781,70.729-27.102
			c16.785-7.604,44.35-20.679,68.415-18.839c29.291,2.239,50.642,6.566,73.042,14.542c11.461,4.081,17.486,7.618,29.746,9.585
			c13.507,2.166,39.474,9.711,52.551,3.636c3.856-1.763,7.712-3.526,11.568-5.288c16.622-14.491,24.624-42.049,36.025-61.475
			c-25.887,0-51.782,0-77.67,0c-3.635,2.093-7.272,4.187-10.907,6.28c-11.99,4.908-34.097,6.43-46.932,3.636
			c-16.634-3.305-33.273-6.61-49.907-9.915c-14.541,0-29.086,0-43.627,0c-12.007,0-24.018,0-36.025,0
			c-16.495,5.331-32.85,9.907-47.924,18.839c-15.484,9.175-29.626,20.619-49.907,24.788c-22.163,4.557-37.863-10.025-41.644-26.441
			C198.752,10.96,200.613,7.059,201,0.663c-44.394,0-88.801,0-133.195,0c-18.727,0-37.46,0-56.187,0
			C6.881,4.629,2.143,8.596-2.594,12.561c0,36.793,0,73.597,0,110.39C-0.966,125.907,2.302,127.419,4.347,129.892z'
                />
                <path
                    fill='#FFFFFF'
                    d='M797.238,114.027c-0.22-0.331-0.441-0.661-0.661-0.992
			C797.004,114.022,796.563,113.432,797.238,114.027z'
                />
                <path
                    fill='#FFFFFF'
                    d='M860.365,0.663c-0.441,0-0.881,0-1.322,0c0.441,0.11,0.881,0.22,1.322,0.331
			C860.365,0.883,860.365,0.773,860.365,0.663z'
                />
                <path
                    fill='#FFFFFF'
                    d='M-2.594,685.147c0,0.331,0,0.661,0,0.992c0.331-0.331,0.661-0.661,0.992-0.992
			C-1.933,685.147-2.263,685.147-2.594,685.147z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1797.358,8.926c5.718-1.723,19.628-8.609,24.788-7.602c0.22-0.22,0.441-0.441,0.661-0.661
			c-29.633,0-59.274,0-88.907,0C1749.617,15.227,1772.851,16.313,1797.358,8.926z'
                />
                <path
                    fill='#FFFFFF'
                    d='M787.323,142.121c0.11-0.441,0.22-0.881,0.331-1.322c-0.22,0-0.441,0-0.661,0
			c0,0.441,0,0.881,0,1.322C787.102,142.121,787.212,142.121,787.323,142.121z'
                />
                <path
                    fill='#FFFFFF'
                    d='M36.076,221.443c-0.11-0.331-0.22-0.661-0.331-0.992c0,0.331,0,0.661,0,0.992
			C35.856,221.443,35.966,221.443,36.076,221.443z'
                />
                <path
                    fill='#FFFFFF'
                    d='M36.406,221.773c-0.22,0-0.441,0-0.661,0c0.11,0.331,0.22,0.661,0.331,0.992
			C36.186,222.434,36.296,222.104,36.406,221.773z'
                />
                <path
                    fill='#FFFFFF'
                    d='M34.093,210.536c0.105,2.869,0.31,8.088,1.983,9.585C35.415,216.926,34.754,213.731,34.093,210.536
			z'
                />
                <path
                    fill='#FFFFFF'
                    d='M784.348,149.722c-0.11,0.331-0.22,0.661-0.331,0.992
			C784.595,150.054,784.737,150.655,784.348,149.722z'
                />
                <path
                    fill='#FFFFFF'
                    d='M782.034,157.324c-0.11,0.551-0.22,1.102-0.331,1.653c0.11,0,0.22,0,0.331,0
			C782.034,158.426,782.034,157.875,782.034,157.324z'
                />
                <path
                    fill='#FFFFFF'
                    d='M156.051,482.875c-0.881-1.212-1.763-2.424-2.644-3.636c0.441,0.991,0.881,1.983,1.322,2.975
			c0.331,0.22,0.661,0.441,0.992,0.661C155.83,482.875,155.94,482.875,156.051,482.875z'
                />
                <path
                    fill='#FFFFFF'
                    d='M164.313,786.944c-0.11,0.22-0.22,0.441-0.331,0.661c0.331-0.22,0.661-0.441,0.992-0.661
			C164.754,786.944,164.534,786.944,164.313,786.944z'
                />
                <path
                    fill='#FFFFFF'
                    d='M181.5,601.528c-0.652-0.856-0.476-0.873-1.653-1.322c0,0.331,0,0.661,0,0.992
			c0.551,0.22,1.102,0.441,1.653,0.661C181.5,601.748,181.5,601.638,181.5,601.528z'
                />
                <path
                    fill='#FFFFFF'
                    d='M164.313,783.308c-0.22,0.11-0.441,0.22-0.661,0.331
			C164.368,783.824,164.08,783.62,164.313,783.308z'
                />
                <path
                    fill='#FFFFFF'
                    d='M174.89,484.858c0,0.11,0,0.22,0,0.331c0.441-0.22,0.881-0.441,1.322-0.661
			c-0.331-0.11-0.661-0.22-0.992-0.331C175.11,484.418,175,484.638,174.89,484.858z'
                />
                <path
                    fill='#FFFFFF'
                    d='M217.525,273.002c-0.11,0.331-0.22,0.661-0.331,0.992
			C217.773,273.334,217.914,273.935,217.525,273.002z'
                />
                <path
                    fill='#FFFFFF'
                    d='M166.296,499.07c-0.551-0.881-1.102-1.763-1.653-2.644c0.11,0.441,0.22,0.881,0.331,1.322
			c0.11,0.331,0.22,0.661,0.331,0.992C165.635,498.85,165.966,498.96,166.296,499.07z'
                />
                <path
                    fill='#FFFFFF'
                    d='M-2.594,828.588c0,0.991,0,1.983,0,2.975c0.11,0,0.22,0,0.331,0
			c0.578-2.021,1.934-4.19,3.668-6.366C-0.403,827.035-1.849,828.323-2.594,828.588z'
                />
                <path
                    fill='#FFFFFF'
                    d='M179.186,774.054c0,0.021,0,0.043,0,0.064c0.046-0.055,0.089-0.109,0.138-0.165
			C179.278,773.986,179.232,774.02,179.186,774.054z'
                />
                <path
                    fill='#FFFFFF'
                    d='M714.611,590.621c0.035,0.073,0.069,0.147,0.104,0.22c-0.035-0.294-0.069-0.588-0.104-0.881
			C714.611,590.181,714.611,590.401,714.611,590.621z'
                />
                <path
                    fill='#FFFFFF'
                    d='M69.788,763.477c-0.22,0-0.441,0-0.661,0c-6.609,4.957-13.221,9.916-19.831,14.873
			c-10.924,8.438-21.342,18.368-31.068,28.093c-1.875,1.875-6.732,7.635-11.343,12.817c3.101-3.022,6.282-5.788,8.368-7.859
			c11.069-10.992,22.043-22.355,34.373-32.059C56.346,774.054,63.068,768.765,69.788,763.477z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1.404,825.196c1.619-1.648,3.528-3.74,5.481-5.935C4.924,821.173,3.004,823.187,1.404,825.196z'
                />
                <path
                    fill='#FFFFFF'
                    d='M124.652,497.418c0,0.331,0,0.661,0,0.992c0.22,0,0.441,0,0.661,0
			C124.886,497.423,125.327,498.013,124.652,497.418z'
                />
                <path
                    fill='#FFFFFF'
                    d='M112.754,504.358c0.881,0.551,1.763,1.102,2.644,1.653c-0.881-0.881-1.763-1.763-2.644-2.644
			C112.754,503.697,112.754,504.028,112.754,504.358z'
                />
                <path
                    fill='#FFFFFF'
                    d='M126.305,515.926c-0.11-0.331-0.22-0.661-0.331-0.992c-0.441,0.331-0.881,0.661-1.322,0.992
			C125.203,515.926,125.754,515.926,126.305,515.926z'
                />
                <path
                    fill='#FFFFFF'
                    d='M144.813,527.164c0.11,0,0.22,0,0.331,0c-0.668-1.642-1.649-2.674-2.975-3.636
			c0.661,1.102,1.322,2.204,1.983,3.305C144.373,526.943,144.593,527.053,144.813,527.164z'
                />
                <path
                    fill='#FFFFFF'
                    d='M125.644,508.325c0.331,0.11,0.661,0.22,0.992,0.331c-0.548-1.319-0.996-1.502-2.314-1.983
			C124.762,507.223,125.203,507.774,125.644,508.325z'
                />
                <path
                    fill='#FFFFFF'
                    d='M124.322,518.24c0.331,0.11,0.661,0.22,0.992,0.331c-0.513-1.383,0.067-0.814-1.322-1.322
			C124.101,517.579,124.212,517.909,124.322,518.24z'
                />
                <path
                    fill='#FFFFFF'
                    d='M120.356,511.63c-0.331-0.11-0.661-0.22-0.992-0.331c-0.22,0.11-0.441,0.22-0.661,0.331
			c-0.11,0.22-0.22,0.441-0.331,0.661c0.331,0.22,0.661,0.441,0.992,0.661c0.22-0.11,0.441-0.22,0.661-0.331
			C120.135,512.291,120.245,511.96,120.356,511.63z'
                />
                <path
                    fill='#FFFFFF'
                    d='M141.839,523.528c0.11,0,0.22,0,0.331,0c-0.11-0.331-0.22-0.661-0.331-0.992
			C141.839,522.867,141.839,523.197,141.839,523.528z'
                />
                <path
                    fill='#FFFFFF'
                    d='M128.949,509.316c0.22-0.22,0.441-0.441,0.661-0.661c-0.22,0-0.441,0-0.661,0
			C128.949,508.875,128.949,509.096,128.949,509.316z'
                />
                <path
                    fill='#FFFFFF'
                    d='M136.551,529.147c-0.331-0.22-0.661-0.441-0.992-0.661c0.22,0.331,0.441,0.661,0.661,0.992
			c0.11,0,0.22,0,0.331,0C136.551,529.367,136.551,529.257,136.551,529.147z'
                />
                <path
                    fill='#FFFFFF'
                    d='M129.279,507.333c-0.22,0-0.441,0-0.661,0C129.206,507.635,128.703,507.656,129.279,507.333z'
                />
                <path
                    fill='#FFFFFF'
                    d='M131.262,517.909c-0.587-1.301-0.168-0.92-1.653-1.322c0,0.441,0,0.881,0,1.322
			C130.161,517.909,130.712,517.909,131.262,517.909z'
                />
                <path
                    fill='#FFFFFF'
                    d='M196.703,761.494c0.441-0.22,0.881-0.441,1.322-0.661c-0.22-0.11-0.441-0.22-0.661-0.331
			C197.144,760.833,196.924,761.164,196.703,761.494z'
                />
                <path
                    fill='#FFFFFF'
                    d='M943.984,389.011c0.467-0.66,0.258-0.507,0.331-0.992
			C944.204,388.35,944.094,388.68,943.984,389.011z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1883.29,504.028c-7.319,10.717,3.822,37.793,7.271,47.924
			c8.071,23.704,13.864,47.969,21.152,72.712c4.362,14.805,9.79,31.573,9.585,49.907c0.22,0,0.441,0,0.661,0
			c0.11-16.414,0.22-32.832,0.331-49.246c-2.534-0.22-5.068-0.441-7.602-0.661c-0.22-0.22-0.441-0.441-0.661-0.661
			c2.754,0.22,5.509,0.441,8.263,0.661c0-39.437,0-78.885,0-118.322C1914.792,503.909,1889.884,494.374,1883.29,504.028z
			 M1902.129,578.392c3.755,1.931,8.192,5.742,12.559,6.28C1911.496,585.811,1903.76,580.498,1902.129,578.392z M1917.333,582.689
			c-5.55-0.432-12.588-3.914-15.534-7.271c5.204,1.86,9.617,5.811,15.534,6.941C1917.333,582.469,1917.333,582.579,1917.333,582.689
			z M1914.688,568.808c-1.873-1.652-3.746-3.305-5.619-4.958C1911.287,565.212,1913.377,566.516,1914.688,568.808z M1910.722,570.13
			c-2.216-0.682-4.289-1.719-5.619-3.305C1906.977,567.926,1908.85,569.028,1910.722,570.13z M1900.146,558.562
			c1.102,1.212,2.203,2.424,3.305,3.636c-1.981-1.04-3.139-2.473-4.627-3.966C1899.265,558.342,1899.705,558.452,1900.146,558.562z
			 M1906.756,574.426c0.22,0.331,0.441,0.661,0.661,0.992c-4.899-1.543-8.166-5.19-10.246-9.585
			C1900.471,568.675,1902.33,572.635,1906.756,574.426z'
                />
                <path
                    fill='#FFFFFF'
                    d='M612.153,866.927c-0.11,0.331-0.22,0.661-0.331,0.992
			C612.636,867.262,612.254,867.582,612.153,866.927z'
                />
                <path
                    fill='#FFFFFF'
                    d='M890.441,956.825c-0.652-0.528-0.451-0.448-1.653-0.661
			C889.34,956.384,889.891,956.605,890.441,956.825z'
                />
                <path
                    fill='#FFFFFF'
                    d='M888.458,955.834c-0.652-0.528-0.451-0.448-1.653-0.661
			C887.357,955.393,887.907,955.613,888.458,955.834z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1523.697,884.444c-4.737,3.856-9.475,7.712-14.212,11.568
			c-7.757,6.241-15.29,15.345-21.153,23.466c4.294-2.094,7.277-7.93,10.576-11.237c4.406-4.406,8.814-8.814,13.22-13.22
			c4.076-3.525,8.153-7.051,12.229-10.576C1524.137,884.444,1523.917,884.444,1523.697,884.444z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1871.392,778.02c0-0.11,0-0.22,0-0.331c-0.441-0.331-0.881-0.661-1.322-0.992
			c-0.11,0.22-0.22,0.441-0.331,0.661C1870.29,777.579,1870.841,777.799,1871.392,778.02z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1865.773,777.689c0.11-0.22,0.22-0.441,0.331-0.661c-0.331-0.22-0.661-0.441-0.992-0.661
			c0,0.22,0,0.441,0,0.661C1865.333,777.249,1865.553,777.469,1865.773,777.689z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1858.172,213.511c-21.564,11.151-21.72,41.786-33.712,62.466
			c-18.927,32.64-41.652,54.487-79.322,68.415c-29.653,10.964-103.494,12.153-114.356,38.009
			c-5.332,12.691,4.658,24.454,8.924,31.398c14.254,23.205,31.655,42.987,44.288,67.754c7.525,14.752,9.794,35.683-2.644,47.263
			c-7.593,7.068-19.488,10.581-29.746,14.873c-11.239,4.702-23.742,10.536-37.348,12.229c0.331-0.22,0.661-0.441,0.992-0.661
			c0-0.11,0-0.22,0-0.331c-7.05,1.652-14.102,3.305-21.152,4.958c-10.685,1.542-21.374,3.085-32.059,4.627
			c-12.795,2.205-27.158,0.057-39.992,1.653c-10.355-0.22-20.713-0.441-31.068-0.661c-4.076-0.11-8.153-0.22-12.229-0.331
			c-16.634-1.652-33.273-3.305-49.907-4.958c0-0.11,0-0.22,0-0.331c0.991-0.11,1.983-0.22,2.975-0.331
			c-8.456-3.836-23.196-0.791-33.381-2.644c-9.847-1.792-18.086-0.728-28.093,0.992c-8.482,1.102-16.967,2.204-25.449,3.305
			c-24.618,6.452-46.276,19.395-64.449,32.72c-9.858,7.228-26.655,22.282-23.136,41.975c5.057,28.292,15.317,47.996,25.119,70.398
			c13.224,30.224,28.381,57.142,39.992,89.898c9.468,26.711,13.42,71.42,2.314,99.814c-6.734,17.216-15.414,30.618-26.11,43.958
			c-27.636,34.466-98.715,70.706-166.576,56.517c-12.2-2.551-24.666-6.181-35.695-9.915c-20.729-7.018-43.821-10.389-49.576-33.381
			c-4.029-16.097,4.6-29.35,13.22-37.678c26.666-25.762,82.782-21.74,115.017-41.975c10.189-6.396,18.803-15.203,23.466-27.102
			c2.065-5.269,1.163-16.469,4.627-20.822c-1.87-2.89-0.273-7.389-2.313-10.907c-1.991-3.433-9.164-30.994-8.593-32.059
			c-2.934-1.081-6.748-13.264-8.593-16.525c-3.991-7.054-6.435-16.807-10.246-23.797c-3.578-6.561-10.024-14.92-13.22-23.466
			c0.771,0,1.542,0,2.313,0c2.482,7.85,7.303,12.009,9.254,19.169c0.33,0.22,0.661,0.441,0.992,0.661
			c-0.666-4.701-13.098-30.766-17.848-32.72c0.11-0.22,0.22-0.441,0.33-0.661c-1.013,0.797-0.513,0.375-0.661,1.322
			c-0.11,0.11-0.22,0.22-0.331,0.331c0.551,0.551,1.102,1.102,1.653,1.653c-0.22,0.11-0.441,0.22-0.661,0.331
			c-0.661-0.991-1.322-1.983-1.983-2.975c0-0.441,0-0.881,0-1.322c0.551,0.11,1.102,0.22,1.653,0.331
			c-0.11-0.441-0.22-0.881-0.33-1.322c-0.67-1.231-1.603-1.812-2.975-2.314c0.675,0.996,0.313,0.869,1.652,1.322
			c-0.441,0.22-0.881,0.441-1.322,0.661c-0.11,0-0.22,0-0.33,0c-6.77-20.727-29.524-44.811-24.458-73.373
			c-0.11-0.331-0.22-0.661-0.33-0.992c-6.76,17.489,11.39,49.009,15.203,62.136c-4.75-4.779-7.238-14.586-9.915-21.153
			c-19.426-47.641,2.43-88.658,31.068-111.712c6.389-5.508,12.78-11.018,19.17-16.525c27.63-20.568,60.882-35.91,97.831-46.932
			c16.405-4.894,34.353-4.874,53.212-7.932c8.372,0.11,16.747,0.22,25.119,0.331c16.043,2.514,31.484,1.747,46.271,4.297
			c44.428,7.659,121.145,7.632,156-7.602c17.595-7.69,17.538-24.688,8.593-41.644c-11.56-21.916-28.114-39.59-38.669-62.136
			c-3.25-6.942-5.836-21.281-1.322-29.085c21.278-36.786,107.903-37.799,150.382-56.517c71.511-31.51,61.72-136.016,138.483-162.941
			c23.695-8.311,57.897-5.768,80.644,0.992c7.339,2.181,18.495,3.283,22.475,8.924c2.129-4.05,0.992-13.086,0.992-18.839
			c0-14.651,0-29.307,0-43.958c-0.551,0-1.102,0-1.653,0c-4.948-8.578-35.028-10.09-47.924-13.551
			c-31.124-8.353-63.338,9.406-86.263,19.169c-5.398,2.534-10.797,5.068-16.195,7.602c-9.087,6.399-31.37,18.594-46.271,16.856
			c-4.044-0.472-8.272-2.068-13.881-1.983c-11.033,0.167-20.922-9.098-26.771-14.873c-23.571-23.27-26.472-61.798-39.661-91.22
			c-61.579,0-123.176,0-184.754,0c0,0.11,0,0.22,0,0.331c14.902,1.316,32.935,7.299,45.61,9.915
			c11.044,2.279,20.526,3.51,30.407,6.61c57.5,18.038,79.707,55.711,104.771,105.763c8.623,17.219,30.646,54.776,25.119,82.297
			c-4.057,20.203-12.514,34.166-27.763,43.958c-2.917,1.873-23.797,11.237-23.797,11.237c-0.774,0.186-0.453,0.014-1.322-0.331
			c-2.882,5.414-32.142,8.476-43.627,10.907c-36.466,7.719-82.08,4.37-110.72,16.856c-4.076,1.652-8.153,3.305-12.229,4.958
			c-23.629,17.82-27.566,33.522-12.559,63.127c4.332,8.546,15.607,31.748,2.644,39.661c-13.751,8.394-32.42,5.437-50.898,8.593
			c-9.914,0.551-19.832,1.102-29.746,1.653c-15.371,3.178-30.063,3.32-45.28,7.271c-37.28,9.681-73.349,20.331-109.729,31.398
			c-38.666,11.762-77.757,20.513-109.399,39.331c-15.121,8.993-28.025,19.768-41.313,30.407
			c-5.684,4.551-10.385,11.075-14.873,16.856c-20.548,26.468-36.768,57.555-47.593,93.865c-4.25,14.254-4.767,34.807-0.661,49.576
			c10.127,36.423,29.564,62.167,46.602,91.22c4.671,7.965,9.588,27.556,0.33,34.373c-5.682,4.185-12.568-1.027-20.822,1.653
			c-24.691,8.015-64.543-1.584-93.534-7.271c-7.846-1.539-20.986-3.032-30.407-1.322c-23.438,4.254-41.555,5.198-60.814,12.89
			c-8.042,3.635-16.086,7.272-24.127,10.907c-4.296,2.313-8.594,4.627-12.89,6.941c-0.22,0.331-0.441,0.661-0.661,0.992
			c1.363,0.749,4.942-1.648,6.941-2.644c-8.221,9.099-19.129,15.063-28.424,23.136c-14.978,13.008-29.151,27.828-40.653,44.288
			c-22.983,32.892-35.118,71.813-59.822,104.11c-20.231,26.449-47.871,43.445-77.339,60.814
			c-17.107,10.083-40.007,23.561-65.441,23.135c0,0.11,0,0.22,0,0.331c9.593,1.864,23.988,0.992,36.025,0.992
			c22.913,0,45.833,0,68.746,0c70.522-0.001,142.762,0.28,212.187-0.661c0-0.11,0-0.22,0-0.331
			c-14.12-1.696-18.397-12.848-25.119-21.813c-8.478-11.308-24.643-34.579-19.831-56.848c7.164-33.15,42.344-56.286,75.026-48.915
			c7.168,1.617,15.006,1.75,21.153,6.61c-0.551-0.11-1.102-0.22-1.653-0.331c5.514,5.678,14.262,8.294,19.5,15.203
			c10.492,13.841,18.657,27.982,27.763,42.966c7.142,11.753,17.64,21.373,25.78,32.059c6.302,8.274,24.361,27.955,32.72,30.076
			c0.22,0.33,0.441,0.661,0.661,0.991c-0.441,0.22-0.881,0.441-1.322,0.661c116.988,0.11,234.012,0.22,351,0.33
			c-0.991-0.11-1.983-0.22-2.975-0.33c-0.11-0.22-0.22-0.441-0.33-0.661c3.442-1.589,7.938-1.191,10.907-2.975
			c45.912-27.589,69.725-73.214,100.144-116.339c31.649-44.868,64.924-86.175,123.61-104.11c28.917-8.838,72.94-7.308,101.466,0.661
			c44.512,12.435,83.278,32.276,119.644,53.542c18.066,9.804,36.137,19.611,54.203,29.415c16.177,9.63,31.931,18.92,49.576,27.432
			c6.169,2.864,12.34,5.729,18.509,8.593c0-68.849,0-137.719,0-206.568c-5.409,1.492-9.17,7.25-14.873,9.585
			c4.356-4.384,10.867-6.857,13.881-12.559c-2.754,2.093-5.509,4.187-8.263,6.28c-5.341,3.265-13.799,4.397-21.814,6.61
			c-2.644-0.11-5.288-0.22-7.932-0.331c-1.66,0.683-1.408,1.98-4.627,1.983c-0.619-1.402-0.372-0.801-0.331-2.644
			c-0.22,0-0.441,0-0.661,0c-0.22,0.771-0.441,1.542-0.661,2.314c-8.508,1.89-29.359-4.133-37.017-6.941
			c-16.267-5.964-32.063-9.332-47.593-16.195c-0.991-0.991-1.983-1.983-2.974-2.975c-3.195-0.881-6.39-1.763-9.585-2.644
			c-2.668-1.265-6.334-3.315-9.585-4.297c-0.11-0.22-0.22-0.441-0.331-0.661c1.322,0.331,2.644,0.661,3.966,0.992
			c0-0.11,0-0.22,0-0.331c-19.189-5.188-36.507-15.785-53.873-22.805c-3.084-0.551-6.17-1.102-9.254-1.653
			c-16.648-5.898-35.711-9.775-55.526-13.551c-17.825-3.396-34.778-0.644-49.576,0.992c-0.881-0.331-1.763-0.661-2.644-0.992
			c-1.353,0.257-4.883,2.044-6.61,2.314c-0.881-0.22-1.763-0.441-2.644-0.661c-4.877,1.536-11.854,5.798-19.5,5.949
			c-0.11,0.22-0.22,0.441-0.331,0.661c0.22,0.331,0.441,0.661,0.661,0.992c0.991-0.331,1.983-0.661,2.975-0.992
			c-0.488,0.639-13.837,4.781-14.542,4.627c-0.11,0.22-0.22,0.441-0.331,0.661c0.661,0.661,1.322,1.322,1.983,1.983
			c-3.576,2.818-8.485,3.993-11.568,7.271c-1.471-0.402-1.086-0.008-1.653-1.322c-1.383,0.513-0.814-0.067-1.322,1.322
			c1.459,0.367,1.684,0.48,2.313,1.653c-1.901,2.331-7.283,7.43-10.907,6.61c-0.382,1.482,0.122,1.151-0.991,2.644
			c0,0.11,0,0.22,0,0.331c9.128-3.993,16.144-11.391,25.449-15.864c-3.856,2.644-7.712,5.288-11.568,7.932
			c-10.664,7.255-20.329,16.474-32.39,22.144c5.398-3.966,10.797-7.933,16.195-11.898c0.11-0.22,0.22-0.441,0.33-0.661
			c-2.203,1.542-4.407,3.085-6.61,4.627c-3.875,2.377-14.394,7.843-20.822,8.924c0-0.11,0-0.22,0-0.331
			c3.323-0.904,10.268-3.352,11.568-6.28c-11.687,2.877-20.58,11.949-34.042,12.89c-1.102-1.322-2.204-2.644-3.305-3.966
			c-0.11,0-0.22,0-0.331,0c0.441,1.212,0.881,2.424,1.322,3.636c0,0.11,0,0.22,0,0.331c-5.327,1.423-12.807-0.569-17.517-1.653
			c-3.279-0.755-8.348-0.534-12.559-1.983c-8.942-3.077-18.265-9.331-25.119-13.881c-1.99-1.321-2.315-3.996-3.966-5.619
			c-1.081-1.062-3.128-0.826-4.297-2.644c-1.277-1.987-0.091-3.56-0.992-5.949c-1.356-3.599-4.89-5.006-5.619-9.915
			c-2.234,2.979,2.811,10.436,4.627,11.237c0.11,0.331,0.22,0.661,0.331,0.992c-1.678-0.595-1.226-0.739-2.644-0.331
			c-2.641-4.869-4.75-10.372-5.949-16.856c-1.208-6.534-1.35-16.057-0.331-22.805c6.103-40.394,32.833-32.505,70.068-39.661
			c73.55-14.136,169.693-20.454,240.28,0c19.229,5.572,50.657,12.775,71.39,3.966c23.178-9.848,30.479-45.05,23.136-77.67
			c-9.56-42.466-29.461-73.969-48.915-106.754c-6.121-10.316-21.808-31.474-15.534-49.576c5.606-16.176,30.907-23.868,52.551-17.517
			c19.634,5.761,37.016,15.076,54.865,22.805c12.993,5.627,25.992,9.784,40.322,14.212c7.271,2.093,14.543,4.187,21.814,6.28
			c0-13.77,0-27.544,0-41.314c-5.728-2.423-11.458-4.848-17.187-7.271c-11.807-6.546-23.027-14.821-30.076-26.11
			c-8.504-13.621-9.18-36.024-4.627-54.203c6.727-26.86,18.152-46.994,51.89-46.602c0-20.6,0-41.206,0-61.805
			c-3.03,0.072-9.824-2.76-14.212-3.636C1891.234,206.184,1871.23,206.758,1858.172,213.511z M1888.578,778.681
			c-1.889,1.019-4.233,1.078-5.619,0C1884.832,778.681,1886.706,778.681,1888.578,778.681z M1553.773,732.079
			c0.11-0.22,0.22-0.441,0.331-0.661c0.11,0,0.22,0,0.331,0C1554.214,731.638,1553.993,731.859,1553.773,732.079z M1567.654,721.172
			c0.441,0,0.881,0,1.322,0c-0.881,0.441-1.763,0.881-2.644,1.322C1566.773,722.054,1567.214,721.613,1567.654,721.172z
			 M1453.959,564.181c12.778,0.991,25.561,1.983,38.339,2.975C1486.959,569.265,1457.768,566.104,1453.959,564.181z
			 M1540.552,567.155c5.508-0.441,11.017-0.881,16.525-1.322c13.407-2.361,33.522-2.164,43.958-6.941c0.441,0,0.881,0,1.322,0
			C1593.449,564.356,1554.923,567.716,1540.552,567.155z M1668.79,561.536c-0.11-0.22-0.22-0.441-0.33-0.661
			C1669.055,561.313,1668.65,561.23,1668.79,561.536z M1785.79,613.757c0,0.11,0,0.22,0,0.331c-0.441-0.331-0.881-0.661-1.322-0.992
			C1784.909,613.316,1785.349,613.537,1785.79,613.757z M1901.138,441.892c-11.771-2.684-26.345-6.303-35.365-12.559
			C1877.56,433.519,1889.351,437.706,1901.138,441.892z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1880.646,778.35c0-0.331,0-0.661,0-0.992c-0.441-0.22-0.881-0.441-1.322-0.661
			C1879.674,778.336,1879.202,777.811,1880.646,778.35z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1543.527,736.706c0-0.11,0-0.22,0-0.331c-0.551-0.331-1.102-0.661-1.653-0.992
			c0,0.331,0,0.661,0,0.992C1542.425,736.486,1542.976,736.596,1543.527,736.706z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1874.697,777.359c0.22,0.11,0.441,0.22,0.661,0.331c0.11,0,0.22,0,0.331,0
			c-0.427-0.987,0.014-0.396-0.661-0.992C1874.917,776.918,1874.807,777.138,1874.697,777.359z'
                />
                <path
                    fill='#FFFFFF'
                    d='M638.924,824.291c-0.331,0.661-0.661,1.322-0.992,1.983
			C638.876,825.466,638.926,825.221,638.924,824.291z'
                />
                <path
                    fill='#FFFFFF'
                    d='M778.399,836.85c0.22,0.11,0.441,0.22,0.661,0.331c0.11-0.22,0.22-0.441,0.331-0.661
			c-0.22-0.331-0.441-0.661-0.661-0.992c-0.11,0.331-0.22,0.661-0.331,0.992C778.399,836.63,778.399,836.74,778.399,836.85z'
                />
                <path
                    fill='#FFFFFF'
                    d='M639.255,824.291c0.467-0.66,0.258-0.507,0.331-0.992
			C639.475,823.63,639.365,823.961,639.255,824.291z'
                />
                <path
                    fill='#FFFFFF'
                    d='M942.662,390.663c0.772-0.76,0.555-0.642,0.661-1.322
			C943.102,389.782,942.882,390.223,942.662,390.663z'
                />
                <path
                    fill='#FFFFFF'
                    d='M932.747,405.867c1.681-1.631,9.283-13.473,9.254-14.873
			C939.129,395.928,934.57,400.033,932.747,405.867z'
                />
                <path
                    fill='#FFFFFF'
                    d='M636.611,828.257c0.467-0.66,0.258-0.507,0.331-0.992
			C636.831,827.596,636.721,827.927,636.611,828.257z'
                />
                <path
                    fill='#FFFFFF'
                    d='M635.619,829.249c-0.441,0.771-0.881,1.543-1.322,2.314C635.1,830.916,636,830.115,635.619,829.249
			z'
                />
                <path
                    fill='#FFFFFF'
                    d='M637.272,827.266c0.467-0.66,0.258-0.507,0.331-0.992
			C637.492,826.605,637.382,826.935,637.272,827.266z'
                />
                <path
                    fill='#FFFFFF'
                    d='M633.966,831.562c-3.856,6.279-7.712,12.56-11.568,18.839
			C624.525,848.729,634.032,833.586,633.966,831.562z'
                />
                <path
                    fill='#FFFFFF'
                    d='M622.068,850.401c-0.22,0.551-0.441,1.102-0.661,1.653
			C622.147,851.263,622.064,851.18,622.068,850.401z'
                />
                <path
                    fill='#FFFFFF'
                    d='M635.95,829.249c0.467-0.66,0.258-0.507,0.331-0.992C636.17,828.588,636.06,828.918,635.95,829.249
			z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1826.112,1046.063c-30.467-18.651-59.714-35.023-89.898-53.542
			c-28.79-17.664-59.085-40.848-105.432-39.661c-2.203,0.22-4.407,0.441-6.61,0.661c-6.72,1.652-13.441,3.305-20.161,4.958
			c-23.02,9.148-36.634,24.18-48.585,44.288c-10.342,17.4-17.28,37.672-26.441,56.187c-2.696,5.45-4.607,16.156-9.915,18.839
			c-0.11,0.22-0.22,0.441-0.331,0.661c4.552,2.607,21.753,0.992,28.754,0.992c24.235,0,48.477,0,72.712,0
			c89.452-0.002,180.686,0.91,269.034-0.661c0-0.11,0-0.22,0-0.331c-3.525-0.661-7.051-1.322-10.576-1.983
			C1861.325,1069.129,1841.984,1055.779,1826.112,1046.063z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1542.866,341.087c7.931-3.966,15.865-7.933,23.797-11.898c0-0.11,0-0.22,0-0.331
			c-0.33,0-0.661,0-0.991,0C1558.218,333.533,1548.175,334.378,1542.866,341.087z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1179.967,752.24c0.987,3.398,2.256,11.218,5.619,13.551
			C1184.205,762.066,1182.913,754.583,1179.967,752.24z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1616.239,314.316c-0.441,0-0.881,0-1.322,0c0.441,0.11,0.881,0.22,1.322,0.331
			C1616.239,314.536,1616.239,314.426,1616.239,314.316z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1603.019,317.621c0.22-0.11,0.441-0.22,0.661-0.331c-0.441,0-0.881,0-1.322,0
			c-5.508,1.542-11.018,3.085-16.526,4.627C1589.24,322.903,1599.95,319.415,1603.019,317.621z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1614.917,314.977c-0.551-0.11-1.102-0.22-1.653-0.331c-3.084,0.771-6.17,1.542-9.254,2.314
			C1607.172,318.061,1611.692,315.541,1614.917,314.977z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1568.315,328.528c0-0.11,0-0.22,0-0.331c-0.331,0-0.661,0-0.991,0
			c-0.22,0.11-0.441,0.22-0.661,0.331C1567.214,328.528,1567.764,328.528,1568.315,328.528z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1193.518,859.325c-5.599,7.444-13.805,11.288-20.161,17.847
			C1178.448,875.572,1193.217,863.633,1193.518,859.325z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1135.679,659.698c-0.11-0.331-0.22-0.661-0.331-0.992c0,0.331,0,0.661,0,0.992
			C1135.459,659.698,1135.569,659.698,1135.679,659.698z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1179.306,751.249c-0.331,0-0.661,0-0.991,0c0.22,0.331,0.441,0.661,0.661,0.992
			C1179.086,751.91,1179.196,751.579,1179.306,751.249z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1150.221,693.74c0.22,0.11,0.441,0.22,0.661,0.331c0.11,0,0.22,0,0.331,0
			c-1.471-4.577-10.123-19.868-13.551-22.144C1141.562,679.205,1147.395,686.257,1150.221,693.74z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1172.365,740.011c0.613,2.257,3.891,4.689,3.966,7.932c0.331-0.11,0.661-0.22,0.992-0.331
			c-0.991-2.313-1.983-4.627-2.975-6.941C1174.18,740.409,1173.892,740.484,1172.365,740.011z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1489.654,761.494c-0.22,0-0.441,0-0.661,0c0,0.331,0,0.661,0,0.992
			C1489.213,762.155,1489.434,761.825,1489.654,761.494z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1538.9,740.011c0.22,0.11,0.441,0.22,0.661,0.331c-0.596-0.667,0.008-0.245-0.992-0.661
			C1538.756,740.109,1538.446,739.938,1538.9,740.011z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1527.993,748.605c0.33-0.22,0.661-0.441,0.991-0.661c-0.22,0-0.441,0-0.661,0
			c-0.771,0.22-1.543,0.441-2.314,0.661C1526.676,749.239,1526.962,749.161,1527.993,748.605z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1539.23,738.028c-0.22,0.441-0.441,0.881-0.661,1.322
			C1539.342,738.59,1539.124,738.708,1539.23,738.028z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1533.281,741.333c-0.22,0-0.441,0-0.661,0C1533.208,741.635,1532.705,741.656,1533.281,741.333z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1480.73,762.486c0-0.11,0-0.22,0-0.331c-1.212-0.661-2.424-1.322-3.636-1.983
			c0.661,0.771,1.322,1.542,1.983,2.314C1479.629,762.486,1480.179,762.486,1480.73,762.486z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1441.4,751.249c0.771,0,1.542,0,2.314,0c0-0.11,0-0.22,0-0.331
			c-1.432-0.551-2.865-1.102-4.297-1.653c0.11,0.331,0.22,0.661,0.33,0.992C1440.298,750.588,1440.849,750.918,1441.4,751.249z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1921.299,142.782c0.11,0,0.22,0,0.33,0c-0.11-0.331-0.22-0.661-0.33-0.992
			C1921.299,142.121,1921.299,142.451,1921.299,142.782z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1415.951,719.85c-0.359-1.133-0.559-2.867-1.322-3.636c0.22,1.212,0.441,2.424,0.661,3.636
			c0,0.22,0,0.441,0,0.661C1415.51,720.291,1415.73,720.071,1415.951,719.85z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1623.841,312.994c-0.661-0.11-1.322-0.22-1.983-0.331c-1.873,0.441-3.746,0.881-5.619,1.322
			C1618.773,313.655,1621.307,313.324,1623.841,312.994z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1426.527,738.689c0.11-0.331,0.22-0.661,0.331-0.992c-0.22-0.22-0.441-0.441-0.661-0.661
			c-0.441,0.331-0.881,0.661-1.322,0.992C1425.526,738.556,1425.326,738.477,1426.527,738.689z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1430.493,743.316c0.11,0,0.22,0,0.331,0c0.11-0.441,0.22-0.881,0.331-1.322
			c-0.11-0.22-0.22-0.441-0.331-0.661c-0.771,0-1.542,0-2.314,0C1429.491,742.216,1429.913,741.855,1430.493,743.316z'
                />
                <path
                    fill='#FFFFFF'
                    d='M229.093,741.003c-0.22,0.331-0.441,0.661-0.661,0.992c0.551,0.11,1.102,0.22,1.653,0.331
			C229.628,741.07,230.093,741.641,229.093,741.003z'
                />
                <path
                    fill='#FFFFFF'
                    d='M250.576,730.096c0,0.441,0,0.881,0,1.322c0.331,0,0.661,0,0.992,0
			C251.128,730.436,251.371,730.675,250.576,730.096z'
                />
                <path
                    fill='#FFFFFF'
                    d='M237.686,736.376c0,0.331,0,0.661,0,0.992c0.331,0,0.661,0,0.992,0
			c0.11-0.331,0.22-0.661,0.331-0.992C238.568,736.376,238.127,736.376,237.686,736.376z'
                />
                <path
                    fill='#FFFFFF'
                    d='M237.025,738.689c-0.331,0-0.661,0-0.992,0c0.11,0.22,0.22,0.441,0.331,0.661
			C236.585,739.13,236.805,738.91,237.025,738.689z'
                />
                <path
                    fill='#FFFFFF'
                    d='M231.737,739.02c0.12,1.4-0.032,1.305,0.661,1.983c0.571,0.566,0.591,0.512,1.653,0
			C233.133,740.455,233.639,739.571,231.737,739.02z'
                />
                <path
                    fill='#FFFFFF'
                    d='M235.042,741.994c-0.441,0-0.881,0-1.322,0C234.616,742.514,234.19,742.938,235.042,741.994z'
                />
                <path
                    fill='#FFFFFF'
                    d='M256.856,726.46c-0.441-0.22-0.881-0.441-1.322-0.661c0.331,0.331,0.661,0.661,0.992,0.992
			c0.11,0,0.22,0,0.331,0C256.856,726.681,256.856,726.571,256.856,726.46z'
                />
                <path
                    fill='#FFFFFF'
                    d='M272.39,720.511c-0.22-0.22-0.441-0.441-0.661-0.661c-0.11,0.11-0.22,0.22-0.331,0.331
			c0,0.11,0,0.22,0,0.331c0.22,0.11,0.441,0.22,0.661,0.331C272.169,720.732,272.28,720.621,272.39,720.511z'
                />
                <path
                    fill='#FFFFFF'
                    d='M260.822,727.121c-0.551-0.11-1.102-0.22-1.653-0.331c0.551,0.551,1.102,1.102,1.653,1.653
			C260.822,728.003,260.822,727.562,260.822,727.121z'
                />
                <path
                    fill='#FFFFFF'
                    d='M262.805,722.825c0-0.441,0-0.881,0-1.322c-0.551-0.22-1.102-0.441-1.653-0.661
			c0.441,0.441,0.881,0.881,1.322,1.322c0,0.22,0,0.441,0,0.661C262.585,722.825,262.695,722.825,262.805,722.825z'
                />
                <path
                    fill='#FFFFFF'
                    d='M272.059,712.579c-0.331-0.22-0.661-0.441-0.992-0.661c0,0.331,0,0.661,0,0.992
			c0.331,0,0.661,0,0.992,0C272.059,712.799,272.059,712.689,272.059,712.579z'
                />
                <path
                    fill='#FFFFFF'
                    d='M262.474,719.189c0,0.22,0,0.441,0,0.661c0.331-0.11,0.661-0.22,0.992-0.331
			c-0.881-0.771-1.763-1.543-2.644-2.314C261.373,717.867,261.924,718.528,262.474,719.189z'
                />
                <path
                    fill='#FFFFFF'
                    d='M263.796,729.104c-0.22-0.22-0.441-0.441-0.661-0.661c0,0.331,0,0.661,0,0.992
			C263.356,729.325,263.576,729.215,263.796,729.104z'
                />
                <path
                    fill='#FFFFFF'
                    d='M187.779,689.774c0.11,0,0.22,0,0.331,0c-0.53-1.484-1.115-1.618-2.314-2.314
			C186.457,688.231,187.118,689.003,187.779,689.774z'
                />
                <path
                    fill='#FFFFFF'
                    d='M190.093,655.07c0.11,0,0.22,0,0.331,0c0-0.11,0-0.22,0-0.331c-0.331-0.22-0.661-0.441-0.992-0.661
			C189.652,654.409,189.873,654.74,190.093,655.07z'
                />
                <path
                    fill='#FFFFFF'
                    d='M191.085,656.062c0.11,0,0.22,0,0.331,0c-0.596-0.667,0.008-0.245-0.992-0.661
			C190.644,655.621,190.864,655.842,191.085,656.062z'
                />
                <path
                    fill='#FFFFFF'
                    d='M183.813,623.672c0.441,0.331,0.881,0.661,1.322,0.992c0.22-0.22,0.441-0.441,0.661-0.661
			c-0.551-0.331-1.102-0.661-1.653-0.992C184.034,623.232,183.924,623.452,183.813,623.672z'
                />
                <path
                    fill='#FFFFFF'
                    d='M189.432,499.731c0.11,0,0.22,0,0.331,0c0-0.11,0-0.22,0-0.331
			c-0.441-0.22-0.881-0.441-1.322-0.661C188.771,499.07,189.101,499.401,189.432,499.731z'
                />
                <path
                    fill='#FFFFFF'
                    d='M187.118,632.926c0.471,1.365,0.623,1.295,1.653,1.983
			C188.262,633.614,188.196,633.598,187.118,632.926z'
                />
                <path
                    fill='#FFFFFF'
                    d='M208.932,664.325c0.513,1.383-0.067,0.814,1.322,1.322
			C209.813,665.206,209.373,664.765,208.932,664.325z'
                />
                <path
                    fill='#FFFFFF'
                    d='M219.178,507.333c-0.331-0.22-0.661-0.441-0.992-0.661
			C217.559,507.595,218.22,507.157,219.178,507.333z'
                />
                <path
                    fill='#FFFFFF'
                    d='M199.678,489.816c-0.691-1.127-0.511-1.202-1.983-1.653c0.331,0.551,0.661,1.102,0.992,1.653
			C199.017,489.816,199.347,489.816,199.678,489.816z'
                />
                <path
                    fill='#FFFFFF'
                    d='M204.305,687.46c-0.441-0.11-0.881-0.22-1.322-0.331c0.11,0.331,0.22,0.661,0.331,0.992
			c0.331,0,0.661,0,0.992,0C204.305,687.901,204.305,687.681,204.305,687.46z'
                />
                <path
                    fill='#FFFFFF'
                    d='M201.33,685.147c-0.11,0.22-0.22,0.441-0.331,0.661c0.331,0.22,0.661,0.441,0.992,0.661
			c0.11,0,0.22,0,0.331,0C201.991,686.028,201.661,685.588,201.33,685.147z'
                />
                <path
                    fill='#FFFFFF'
                    d='M957.535,371.824c-2.534,3.195-5.068,6.39-7.602,9.585
			C952.331,379.661,957.298,374.366,957.535,371.824z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1001.162,317.951c-1.102,2.093-2.204,4.187-3.305,6.28
			C999.197,323.05,1001.399,319.49,1001.162,317.951z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1204.425,306.053c-0.22,0.441-0.441,0.881-0.661,1.322c0.11,0,0.22,0,0.33,0
			C1204.515,306.66,1204.701,306.772,1204.425,306.053z'
                />
                <path
                    fill='#FFFFFF'
                    d='M997.196,325.223c0.467-0.66,0.258-0.507,0.331-0.992
			C997.416,324.562,997.306,324.892,997.196,325.223z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1257.306,366.867c10.446-1.922,24.58-8.965,36.146-16.359
			c-7.502,4.387-15.896,8.032-22.926,11.071C1266.12,363.341,1261.713,365.104,1257.306,366.867z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1304.002,343.117c2.117-1.644,3.989-3.223,5.524-4.674c-0.22-0.11-0.441-0.22-0.661-0.331
			C1307.488,339.863,1305.833,341.525,1304.002,343.117z'
                />
                <path
                    fill='#FFFFFF'
                    d='M948.941,382.731c0.467-0.66,0.258-0.507,0.331-0.992
			C949.162,382.07,949.052,382.401,948.941,382.731z'
                />
                <path
                    fill='#FFFFFF'
                    d='M996.535,326.214c0.467-0.66,0.258-0.507,0.331-0.992
			C996.755,325.553,996.645,325.884,996.535,326.214z'
                />
                <path
                    fill='#FFFFFF'
                    d='M947.619,383.723c-0.331,0.551-0.661,1.102-0.992,1.653
			C947.566,384.601,947.509,384.507,947.619,383.723z'
                />
                <path
                    fill='#FFFFFF'
                    d='M945.636,386.697c0.772-0.76,0.555-0.642,0.661-1.322
			C946.077,385.816,945.857,386.257,945.636,386.697z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1252.679,368.519c1.542-0.441,3.085-0.881,4.627-1.322c0-0.11,0-0.22,0-0.331
			c-0.33,0-0.661,0-0.992,0C1255.103,367.418,1253.891,367.968,1252.679,368.519z'
                />
                <path
                    fill='#FFFFFF'
                    d='M944.645,388.019c0.772-0.76,0.555-0.642,0.661-1.322
			C945.086,387.138,944.865,387.579,944.645,388.019z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1318.45,327.867c-2.864,3.305-5.729,6.61-8.593,9.915
			C1312.604,336.576,1318.456,330.506,1318.45,327.867z'
                />
                <path
                    fill='#FFFFFF'
                    d='M281.644,709.604c0.718,0.868,0.654,0.945,1.983,1.322
			C282.966,710.486,282.305,710.045,281.644,709.604z'
                />
                <path
                    fill='#FFFFFF'
                    d='M285.941,702.994c0.11,0.441,0.22,0.881,0.331,1.322c0.22,0.11,0.441,0.22,0.661,0.331
			C286.602,704.096,286.271,703.545,285.941,702.994z'
                />
                <path
                    fill='#FFFFFF'
                    d='M294.534,645.155c-0.331,0-0.661,0-0.992,0c0.11,0.22,0.22,0.441,0.331,0.661
			C294.093,645.596,294.313,645.376,294.534,645.155z'
                />
                <path
                    fill='#FFFFFF'
                    d='M279,715.884c-1.763-2.203-3.526-4.407-5.288-6.61C274.349,712.659,276.125,714.239,279,715.884z'
                />
                <path
                    fill='#FFFFFF'
                    d='M275.364,701.011c-0.352,2.054,1.482,4.329,3.305,5.288
			C277.568,704.537,276.466,702.774,275.364,701.011z'
                />
                <path
                    fill='#FFFFFF'
                    d='M287.924,365.214c-2.203,5.508-4.407,11.018-6.61,16.525c0.11,0,0.22,0,0.331,0
			C282.715,379.205,289.393,366.999,287.924,365.214z'
                />
                <path
                    fill='#FFFFFF'
                    d='M393.025,362.57c-0.558-2.83-1.032-6.117-2.644-7.932c0.661,2.534,1.322,5.068,1.983,7.602
			C392.585,362.35,392.805,362.46,393.025,362.57z'
                />
                <path
                    fill='#FFFFFF'
                    d='M271.729,708.282c0.11,0,0.22,0,0.331,0c0-0.11,0-0.22,0-0.331
			c-0.441-0.331-0.881-0.661-1.322-0.992C271.068,707.401,271.398,707.842,271.729,708.282z'
                />
                <path
                    fill='#FFFFFF'
                    d='M1304.002,343.117c-3.068,2.383-6.663,4.906-10.55,7.391
			C1297.314,348.249,1300.926,345.791,1304.002,343.117z'
                />
                <path
                    fill='#FFFFFF'
                    d='M369.89,324.231c0.991,1.873,1.983,3.746,2.975,5.619c0.441,0.331,0.881,0.661,1.322,0.992
			C372.754,328.638,371.322,326.434,369.89,324.231z'
                />
                <path
                    fill='#FFFFFF'
                    d='M377.161,334.807c0.551,0.881,1.102,1.763,1.653,2.644c0.441,0.331,0.881,0.661,1.322,0.992
			C379.144,337.231,378.152,336.019,377.161,334.807z'
                />
            </g>
        </g>
    </svg>
);

export { NotFoundSvg };
